import Backbone from 'backbone';
import ko from 'knockout';

import ViewModel from './keywordModel';
import template from './keyword.pug';
import { setPosition } from './const';

export class KeywordContextualAttributeView extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.keywordId = targetId;
    this.viewModel = new ViewModel({
      i18n,
    });
  }


  render() {
    const {
      deps,
      keywordId,
    } = this;

    deps.jsdata.Keyword.findAll({
      limit: 1,
      select: ['Id', 'QualityScore'],
      where: { Id: { $eq: keywordId } },
    }).then((response) => {
      if (response.length && response.length > 0) {
        this.viewModel.updateAttribute({
          keywordQualityScore: response[0].QualityScore ?
            response[0].QualityScore.OverallQualityScore : null,
        });
        this.$el.html(template());
        ko.applyBindings(this.viewModel, this.el);
        const container = this.$el.children('.contextual-tooltip-container');
        setPosition(container);
      }
    });
    return this;
  }
}
